<!--字段配置Ec-->
<template>
  <div class="field-main">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="基本字段" name="first">
        <EcBasicField :origin="origin"></EcBasicField>
      </el-tab-pane>
      <el-tab-pane v-if="origin!='xbb'" label="标签配置" name="second" lazy=’true’>
        <EcLabelConfig :origin="origin"></EcLabelConfig>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
  import EcBasicField from '@/components/client/crm/EcBasicField'
  import EcLabelConfig from '@/components/client/crm/EcLabelConfig'
  export default {
    props: {
      origin: {
        type: String
      }
    },
    components: {
      EcBasicField,
      EcLabelConfig
    },
    data () {
      return {
        activeName: 'first'
      }
    }
  }
</script>


<style lang="scss">
.field-main .el-tabs__nav-wrap:after{
  height:1px;
}
</style>



// WEBPACK FOOTER //
// src/components/client/crm/EcField.vue